import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from 'infrastructure/common/model/api.query';
import { MessagingUserModulePushOutput } from 'infrastructure/graphql/messaging/user/model/messaging-user-module-push.output';

export interface OwnedUserModulePushesParams {
	readonly organizationModuleId?: string;
	readonly ownerId?: string;
}

@Injectable({ providedIn: 'root' })
export class OwnedUserModulePushesApiQuery extends ApiQuery<
	MessagingUserModulePushOutput[],
	OwnedUserModulePushesParams
> {
	client = 'messaging';
	document = gql`
		query OwnedUserModulePushes($organizationModuleId: UUID, $ownerId: UUID) {
			ownedUserModulePushes(
				organizationModuleId: $organizationModuleId
				ownerId: $ownerId
			) {
				contactEmailAddress
				pushOrgModuleId
				contactLanguage
				contactName
				contactId
				emailId
				status
			}
		}
	`;
	method = 'ownedUserModulePushes';
}
